import type { ActionFields } from './types';
import { ACTION_TYPE } from './types';

export const ACTION_FIELDS: ActionFields = {
	[ACTION_TYPE.GET_LINEAGE]: [
		{
			label: 'ID',
			value: 'from_entity_id',
			group: 'From Entity',
			type: 'string',
		},
		{
			label: 'ID',
			value: 'to_entity_id',
			group: 'To Entity',
			type: 'string',
		},
		{
			label: 'Entity Type',
			value: 'from_entity__entity_type',
			group: 'From Entity',
			type: 'string',
		},
		{
			label: 'Entity Type',
			value: 'to_entity__entity_type',
			group: 'To Entity',
			type: 'string',
		},
		{
			label: 'Native Type',
			value: 'from_entity__native_type',
			group: 'From Entity',
			type: 'string',
		},
		{
			label: 'Native Type',
			value: 'to_entity__native_type',
			group: 'To Entity',
			type: 'string',
		},
		{
			label: 'Integration ID',
			value: 'from_entity__integration_id',
			group: 'From Entity',
			type: 'string',
		},
		{
			label: 'Integration ID',
			value: 'to_entity__integration_id',
			group: 'To Entity',
			type: 'string',
		},
		{
			label: 'Integration Type',
			value: 'from_entity__integration__type',
			group: 'From Entity',
			type: 'string',
		},
		{
			label: 'Integration Type',
			value: 'to_entity__integration__type',
			group: 'To Entity',
			type: 'string',
		},
		{
			label: 'Direction',
			value: 'direction',
			type: 'string',
		},
		{
			label: 'Workspace ID',
			value: 'workspace_id',
			type: 'string',
		},
		{
			label: 'Integration ID',
			value: 'integration_id',
			type: 'string',
		},
		{
			label: 'Is Manual',
			value: 'is_manual',
			type: 'boolean',
		},
		{
			label: 'Archived',
			value: 'archived',
			type: 'boolean',
		},
	],
	[ACTION_TYPE.GET_LINEAGE_COUNT]: [
		{
			label: 'ID',
			value: 'from_entity_id',
			group: 'From Entity',
			type: 'string',
		},
		{
			label: 'ID',
			value: 'to_entity_id',
			group: 'To Entity',
			type: 'string',
		},
		{
			label: 'Entity Type',
			value: 'from_entity__entity_type',
			group: 'From Entity',
			type: 'string',
		},
		{
			label: 'Entity Type',
			value: 'to_entity__entity_type',
			group: 'To Entity',
			type: 'string',
		},
		{
			label: 'Native Type',
			value: 'from_entity__native_type',
			group: 'From Entity',
			type: 'string',
		},
		{
			label: 'Native Type',
			value: 'to_entity__native_type',
			group: 'To Entity',
			type: 'string',
		},
		{
			label: 'Integration ID',
			value: 'from_entity__integration_id',
			group: 'From Entity',
			type: 'string',
		},
		{
			label: 'Integration ID',
			value: 'to_entity__integration_id',
			group: 'To Entity',
			type: 'string',
		},
		{
			label: 'Integration Type',
			value: 'from_entity__integration__type',
			group: 'From Entity',
			type: 'string',
		},
		{
			label: 'Integration Type',
			value: 'to_entity__integration__type',
			group: 'To Entity',
			type: 'string',
		},
		{
			label: 'Direction',
			value: 'direction',
			type: 'string',
		},
		{
			label: 'Workspace ID',
			value: 'workspace_id',
			type: 'string',
		},
		{
			label: 'Is Manual',
			value: 'is_manual',
			type: 'boolean',
		},
		{
			label: 'Archived',
			value: 'archived',
			type: 'boolean',
		},
	],
	[ACTION_TYPE.VISUALIZE_LINEAGE_COUNT]: [],
	[ACTION_TYPE.GET_RESOURCE]: [
		{
			label: 'ID',
			value: 'id',
			type: 'string',
		},
		{
			label: 'Databuilder ID',
			value: 'databuilder_id',
			type: 'string',
		},
		{
			label: 'Title',
			value: 'title',
			type: 'string',
		},
		{
			label: 'Entity Type',
			value: 'entity_type',
			type: 'string',
		},
		{
			label: 'Native Type',
			value: 'native_type',
			type: 'string',
		},
		{
			label: 'Integration ID',
			value: 'integration_id',
			type: 'string',
		},
		{
			label: 'Integration Type',
			value: 'integration__type',
			type: 'string',
		},
		{
			label: 'Workspace ID',
			value: 'workspace_id',
			type: 'string',
		},
		{
			label: 'Parent ID',
			value: 'parent_id',
			type: 'string',
		},
		{
			label: 'Is Stale',
			value: 'stale',
			type: 'boolean',
		},
		{
			label: 'Is Archived',
			value: 'archived',
			type: 'boolean',
		},
	],
	[ACTION_TYPE.GET_RESOURCE_COUNT]: [
		{
			label: 'ID',
			value: 'id',
			type: 'string',
		},
		{
			label: 'Databuilder ID',
			value: 'databuilder_id',
			type: 'string',
		},
		{
			label: 'Title',
			value: 'title',
			type: 'string',
		},
		{
			label: 'Entity Type',
			value: 'entity_type',
			type: 'string',
		},
		{
			label: 'Native Type',
			value: 'native_type',
			type: 'string',
		},
		{
			label: 'Integration ID',
			value: 'integration_id',
			type: 'string',
		},
		{
			label: 'Integration Type',
			value: 'integration__type',
			type: 'string',
		},
		{
			label: 'Workspace ID',
			value: 'workspace_id',
			type: 'string',
		},
		{
			label: 'Parent ID',
			value: 'parent_id',
			type: 'string',
		},
		{
			label: 'Is Stale',
			value: 'stale',
			type: 'boolean',
		},
		{
			label: 'Is Archived',
			value: 'archived',
			type: 'boolean',
		},
	],
	[ACTION_TYPE.GET_WORKSPACE_USERS]: [],
	[ACTION_TYPE.GET_WORKSPACE_ADMINS]: [],
	[ACTION_TYPE.QUERY_ELASTICSEARCH]: [
		{
			label: 'Catalog Filter',
			value: 'catalog_filter',
			type: 'string',
			display: 'textarea',
		},
		{
			label: 'Start',
			value: 'start',
			type: 'string',
		},
		{
			label: 'End',
			value: 'end',
			type: 'string',
		},
		{
			label: 'Direct Elasticsearch Query Body',
			value: 'direct_es_query',
			type: 'boolean',
		},
		{
			label: 'ES Index',
			value: 'index',
			type: 'select',
			options: [
				'entity',
				'query',
				'notification',
				'activity_log',
				'query_execution',
			],
		},
	],
	[ACTION_TYPE.DOWNLOAD_S3_FILE]: [
		{
			label: 'File Path',
			value: 'file_path',
			type: 'string',
		},
		{
			label: 'Bucket',
			value: 'bucket',
			type: 'string',
		},
	],
	[ACTION_TYPE.INSPECT_CACHE]: [
		{
			label: 'Cache Key',
			value: 'cache_key',
			type: 'string',
		},
	],
	[ACTION_TYPE.DELETE_FROM_CACHE]: [
		{
			label: 'Cache Key',
			value: 'cache_key',
			type: 'string',
		},
	],
	[ACTION_TYPE.CLEAR_QUERY_PARSE_RESULTS]: [
		{
			label: 'Integration ID',
			value: 'integration_id',
			type: 'string',
		},
		{
			label: 'Databuilder Prefix (optional)',
			value: 'databuilder_prefix',
			type: 'string',
		},
	],
	[ACTION_TYPE.UPDATE_ALLOWED_DOMAINS]: [
		{
			label: 'Workspace ID',
			value: 'workspace_id',
			type: 'string',
		},
		{
			label: 'Allowed Domains (comma separated)',
			value: 'allowed_domains',
			type: 'string',
			display: 'textarea',
		},
		{
			label: 'One Time SuperUser Token',
			value: 'totp',
			type: 'string',
		},
	],
	[ACTION_TYPE.UPDATE_DISABLED]: [
		{
			label: 'Workspace ID',
			value: 'workspace_id',
			type: 'string',
		},
		{
			label: 'Disabled',
			value: 'disabled',
			type: 'boolean',
		},
		{
			label: 'One Time Super User Token',
			value: 'totp',
			type: 'string',
		},
	],
	[ACTION_TYPE.GET_WORKSPACE]: [
		{
			label: 'Workspace ID or Name',
			value: 'workspace_id',
			type: 'string',
		},
	],
	[ACTION_TYPE.REGENERATE_WORKSPACE_POLICIES]: [
		{
			label: 'Workspace ID',
			value: 'workspace_id',
			type: 'string',
		},
		{
			label: 'Complete Rebuild (slow)',
			value: 'complete_rebuild',
			type: 'boolean',
		},
	],
	[ACTION_TYPE.UPDATE_WORKSPACE_QUALITY_FLAGS]: [
		{
			label: 'Workspace ID',
			value: 'workspace_id',
			type: 'string',
		},
	],
	[ACTION_TYPE.RESET_DQS2_POLICIES]: [
		{
			label: 'Workspace ID',
			value: 'workspace_id',
			type: 'string',
		},
		{
			label: 'One Time SuperUser Token (TOTP)',
			value: 'totp',
			type: 'string',
		},
	],
	[ACTION_TYPE.TEST_CONNECTIVITY]: [
		{
			label: 'Integration ID',
			value: 'integration_id',
			type: 'string',
		},
		{
			label: 'Override JSON',
			value: 'override_json',
			type: 'string',
			display: 'textarea',
		},
		{
			label: 'One Time SuperUser Token (TOTP)',
			value: 'superuser_totp',
			type: 'string',
		},
	],
	[ACTION_TYPE.TEST_REVERSE_TUNNEL]: [
		{
			label: 'SSH Tunnel ID (ENSURE YOU HAVE PERMISSION)',
			value: 'ssh_tunnel_id',
			type: 'string',
		},
		{
			label: 'Target Hostname',
			value: 'target_hostname',
			type: 'string',
		},
		{
			label: 'Target Port',
			value: 'target_port',
			type: 'string',
		},
		{
			label: 'Timeout Seconds',
			value: 'timeout_seconds',
			type: 'string',
		},
		{
			label: 'One Time SuperUser Token (TOTP)',
			value: 'totp',
			type: 'string',
		},
	],
	[ACTION_TYPE.BULK_EXPORT]: [
		{
			label: 'Workspace ID',
			value: 'workspace_id',
			type: 'string',
		},
		{
			label: 'Entity Type',
			value: 'entity_type',
			type: 'select',
			options: [
				'table',
				'column',
				'dashboard',
				'chart',
				'job',
				'event',
				'glossary',
				'document',
				'tag',
			],
		},
		{
			label: 'Recipient Email (optional)',
			value: 'email',
			type: 'string',
		},
		{
			label: 'One Time SuperUser Token (TOTP)',
			value: 'totp',
			type: 'string',
		},
	],
	[ACTION_TYPE.REGENERATE_TEAMS_PERMISSIONS]: [
		{
			label: 'Workspace ID',
			value: 'workspace_id',
			type: 'string',
		},
		{
			label: 'Integration ID',
			value: 'integration_id',
			type: 'string',
		},
		{
			label: 'Create Ancestry',
			value: 'create_ancestry',
			type: 'boolean',
		},
	],
	[ACTION_TYPE.GENERATE_WORKSPACE_LINEAGE]: [
		{
			label: 'Workspace ID',
			value: 'workspace_id',
			type: 'string',
		},
	],
	[ACTION_TYPE.REMOVE_DISABLED_USERS_FROM_TEAMS]: [
		{
			label: 'Workspace ID',
			value: 'workspace_id',
			type: 'string',
		},
	],
};
